export default "__VITE_ASSET__CNPA2FrV__"